import { Flex } from "antd"
import React, { useEffect } from "react"

import { FixedContainer } from "../../components/FixedContainer.tsx"
import { generateDocumentTitle } from "../../constants/document-title.ts"
import { useAppSelector } from "../../hooks/use-app-selector.ts"
import { BranchSetupFlow } from "../Branches/components/BranchSetupFlow.tsx"
import { CompanyDashboardPage } from "../Branches/pages/CompanyDashboardPage.tsx"
import { selectIsCompanyMode } from "../Branches/redux/branches.slice.ts"
import { HomeFavoriteReports } from "../ReportsPage/components/home/HomeFavoriteReports.tsx"
import { HomeBelowSections, HomeGreeting } from "./components/HomeSections.tsx"
import { MobileHome } from "./components/MobileHome"
import { WidgetsDashboard } from "./components/Portfolio/WidgetsDashboard.tsx"

const WidgetsHome = () => {
  useEffect(() => {
    generateDocumentTitle("Home")
  }, [])

  return (
    <FixedContainer>
      {/* `hidden` would make this a second scroller, stranding the column's bottom reserve as a blank band */}
      <Flex vertical gap={"middle"} className={"overflow-x-clip"}>
        <BranchSetupFlow />
        <HomeGreeting />
        <WidgetsDashboard />
        <HomeFavoriteReports />
        <HomeBelowSections />
      </Flex>
    </FixedContainer>
  )
}

const MobileWidgetsHome = () => {
  useEffect(() => {
    generateDocumentTitle("Home")
  }, [])

  return (
    <FixedContainer>
      <div className={"overflow-x-clip"}>
        <BranchSetupFlow />
        <MobileHome />
      </div>
    </FixedContainer>
  )
}

const HomePage = () => {
  const isMobile = useAppSelector((state) => state.nav.isMobile)
  const isCompanyMode = useAppSelector(selectIsCompanyMode)

  // The company overview replaces this page's content entirely while a
  // multi-branch owner is looking at the whole company — the single-branch
  // operational Home (with its project-creation/search/filter toolbar)
  // stays exactly as it was for every other case, mobile included.
  if (isCompanyMode) return <CompanyDashboardPage />

  return isMobile ? <MobileWidgetsHome /> : <WidgetsHome />
}

export default HomePage
